/* PROJECTS */
export const GET_PROJECTS = "GET_PROJECTS"
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS"
export const GET_PROJECTS_FAIL = "GET_PROJECTS_FAIL"

export const GET_MY_PROJECTS = "GET_MY_PROJECTS"
export const GET_MY_PROJECTS_SUCCESS = "GET_MY_PROJECTS_SUCCESS"
export const GET_MY_PROJECTS_FAIL = "GET_MY_PROJECTS_FAIL"

export const GET_CREATED_EVENTS = "GET_CREATED_EVENTS"
export const GET_CREATED_EVENTS_SUCCESS = "GET_CREATED_EVENTS_SUCCESS"
export const GET_CREATED_EVENTS_FAIL = "GET_CREATED_EVENTS_FAIL"

/* PROJECTS DETAIL*/
export const GET_PROJECT_DETAIL = "GET_PROJECT_DETAIL"
export const GET_PROJECT_DETAIL_SUCCESS = "GET_PROJECT_DETAIL_SUCCESS"
export const GET_PROJECT_DETAIL_FAIL = "GET_PROJECT_DETAIL_FAIL"

export const ADD_NEW_PROJECT = "ADD_NEW_PROJECT"
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS"
export const ADD_PROJECT_FAIL = "ADD_PROJECT_FAIL"

export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS"
export const UPDATE_PROJECT_FAIL = "UPDATE_PROJECT_FAIL"

export const DELETE_PROJECT = "DELETE_PROJECT"
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS"
export const DELETE_PROJECT_FAIL = "DELETE_PROJECT_FAIL"

export const CHANGE_SIGNEDIN_EVENTS = "CHANGE_SIGNEDIN_EVENTS"
export const EDIT_EVENT_DETAILS = "EDIT_EVENT_DETAILS"

export const ACCEPT_APPLICATIONS = "ACCEPT_APPLICATIONS"
export const ACCEPT_APPLICATIONS_SUCCESS = "ACCEPT_APPLICATIONS_SUCCESS"
export const ACCEPT_APPLICATIONS_FAIL = "ACCEPT_APPLICATIONS_FAIL"

export const REJECT_APPLICATIONS = "REJECT_APPLICATIONS"
export const REJECT_APPLICATIONS_SUCCESS = "REJECT_APPLICATIONS_SUCCESS"
export const REJECT_APPLICATIONS_FAIL = "REJECT_APPLICATIONS_FAIL"